import { Outlet, ScrollRestoration } from 'react-router-dom'; 
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';

export default function UserLayout() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
    AOS.refresh();
  }, []);

  return (
    <>
      <Navbar />
      <main className="pt-[153px] min-h-screen">
        <Outlet />
      </main>
      <Footer />
      <ScrollRestoration />
    </>
  );
}